/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';
import {getPartyDisplayString} from 'parties/GetPartyDisplayString';
import EntityStore from 'stores/EntityStore';
import Avatar from 'ui-library/avatar/Avatar';
import {AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {SingleEntityInput} from 'ui-library/entity-input/SingleEntityInput';
import {Header1} from 'ui-library/Headers';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {TagsInputSize} from 'ui-library/tags-input/TagsInputConstants';

export interface InviteMembersSectionProps {
  members: Array<any>;
  onInviteMember: (...args: Array<any>) => any;
  onRemoveInvite: (...args: Array<any>) => any;
}

class InviteMembersSection extends React.Component<InviteMembersSectionProps> {
  _handleSubmit = ({entity, email}: any): void => {
    if (entity) {
      this.props.onInviteMember(entity);
      return;
    }
    assert(email, 'SingleEntityInput should return an email or entity.');
    this.props.onInviteMember({email});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
  _filterInvites = (tag: any, suggestions: any) =>
    // Remove any members invites already added.
    suggestions.filter(
      (suggestion: any) =>
        ![EntityStore.currentUser(), ...this.props.members].some(
          (member) => member.email === suggestion.email || member.handle === suggestion.handle
        )
    );

  override render(): JSX.Element {
    return (
      <div>
        <div className="u-spacing-bottom u-vertical-center-items">
          <div className="featureBanner-stepNumber">2</div>
          <Header1>Invite your organization members</Header1>
        </div>
        <SingleEntityInput
          allowEmails={BenchlingConfig.ENABLE_USER_SIGNUPS}
          allowTeams={false}
          allowOrganizations={false}
          buttonProps={{
            buttonStyle: ButtonStyle.SECONDARY,
            size: ButtonSize.LARGE,
            text: 'Invite',
          }}
          filterOptions={this._filterInvites}
          onSubmit={this._handleSubmit}
          size={TagsInputSize.LARGE}
        />
        <div className="createOrganizationPage-membersList">
          {[EntityStore.currentUser()].concat(this.props.members).map((member, i) => {
            const handleRemoveInvite = (): void => {
              this.props.onRemoveInvite(i - 1);
            };
            return (
              <div className="createOrganizationPage-membersList-member" key={`member-${i}`}>
                <div>
                  <Avatar className="u-small-spacing-right" size={AvatarSize.SMALL} entity={member} />
                  {getPartyDisplayString(member) ?? member.email}
                </div>
                {i > 0 && (
                  <BenchlingIcon className="faded u-pointer" icon="close" onClick={handleRemoveInvite} />
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default InviteMembersSection;
